import * as React from "react";
import { useTealiumEventProperties, useTrackPageView } from "@grandvisionhq/svc-tealium/events";
import { mapProductToTealiumViewProperties } from "../../../../../../mappers/tealium/mappers/tealium/map-product-to-tealium-view-properties.js";
import { useProductData } from "../../../../../../context/context/product-context-hooks.js";
const TealiumPageView = ({ children }) => {
  const { commonEventProperties, getCommonUserProperties } = useTealiumEventProperties();
  const { product, activeVariant } = useProductData();
  const pdpPageView = React.useCallback(
    async () => {
      const commonUserProperties = await getCommonUserProperties();
      if (!commonUserProperties) return;
      return {
        ...mapProductToTealiumViewProperties(product, activeVariant),
        ...commonEventProperties,
        ...commonUserProperties
      };
    },
    // Only need to trigger this page view on initial render & whenever the active variant changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [activeVariant, getCommonUserProperties]
  );
  useTrackPageView(pdpPageView);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, children);
};
export {
  TealiumPageView
};
//# sourceMappingURL=TealiumPageView.js.map
